module.exports = __webpack_public_path__ + "media/img/frontend_application/bg-upgrade-text-mobile-2892fa38bce0c2f590d33c7c2c0e2fc0.png";